const travellingReason = "STUDIES"
const britamInsurer = "britam-d171-aa7c-4405-ad9c-4f8ab9ee0036"
const DataStorageKey = "data"
// const britamInsurer = 
export { travellingReason, britamInsurer, DataStorageKey }